import Vue from "vue"
import Router from "vue-router"
import Search from "./src/components/Search"

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes:
        [{
            path: "/",
            name: "home",
            component: Search,
            children: [{
                path: "result/:trackingNumber",
                name: "result",
                component: Search
            }]
        }]
})

export default router